import { Table, Input, Button, Popconfirm, Select, Form } from "antd";
import * as MovieApi from "movieapi";
import AuthService from "src/helpers/AuthService";
import * as React from "react";

const FormItem = Form.Item;
const EditableContext = React.createContext();

const EditableRow = ({ form, index, ...props }) => (
  <EditableContext.Provider value={form}>
    <tr {...props} />
  </EditableContext.Provider>
);

const EditableFormRow = Form.create()(EditableRow);

class EditableCell extends React.Component {
  state = {
    editing: false,
    genreResults: []
  };

  componentDidMount() {
    if (this.props.editable) {
      document.addEventListener("click", this.handleClickOutside, true);
    }
  }

  componentWillUnmount() {
    if (this.props.editable) {
      document.removeEventListener("click", this.handleClickOutside, true);
    }
  }

  toggleEdit = () => {
    const editing = !this.state.editing;
    this.setState({ editing }, () => {
      if (editing) {
        this.input.focus();
      }
    });
  };

  handleClickOutside = e => {
    const { editing } = this.state;
    // check to see if we're clicking a drop down
    if (
      editing &&
      e.target.className ===
        "ant-select-dropdown-menu-item ant-select-dropdown-menu-item-active"
    ) {
      return;
    }

    if (editing && this.cell !== e.target && !this.cell.contains(e.target)) {
      this.save();
    }
  };

  save = () => {
    const { record, handleSave } = this.props;
    this.form.validateFields((error, values) => {
      if (error) {
        return;
      }
      this.toggleEdit();
      handleSave({ ...record, ...values });
    });
  };

  handleSearch = value => {
    if (!value) {
      this.setState({ genreResults: [] });
    } else {
      const api = new MovieApi.AutocompleteApi(
        new AuthService().getConfiguration(),
        process.env.REACT_APP_BASE_URL
      );
      api
        .getAutocompleteResultsForGenres({ text: value })
        .then(result => this.setState({ genreResults: result }));
    }
  };

  render() {
    const { editing } = this.state;
    const {
      editable,
      dataIndex,
      title,
      record,
      index,
      handleSave,
      ...restProps
    } = this.props;

    // autocomplete options for the language
    const genreChildren =
      (this.state.genreResults &&
        this.state.genreResults.map(result => {
          return (
            <Select.Option key={result.genre_name}>
              {result.genre_name}
            </Select.Option>
          );
        })) ||
      [];

    return (
      <td ref={node => (this.cell = node)} {...restProps}>
        {editable ? (
          <EditableContext.Consumer>
            {form => {
              this.form = form;
              return editing ? (
                <FormItem style={{ margin: 0 }}>
                  {form.getFieldDecorator(dataIndex, {
                    initialValue: record[dataIndex],
                    rules: [
                      {
                        message: `${title} is required.`,
                        required: false
                      }
                    ]
                  })(
                    <Select
                      showSearch={true}
                      filterOption={false}
                      allowClear={true}
                      onSearch={this.handleSearch}
                      onSelect={this.handleChange}
                      placeholder="enter movie language"
                      defaultActiveFirstOption={false}
                      ref={node => (this.input = node)}
                      style={{ width: "100%" }}
                    >
                      {genreChildren}
                    </Select>
                  )}
                </FormItem>
              ) : (
                <div
                  className="editable-cell-value-wrap"
                  style={{ paddingRight: 24 }}
                  onClick={this.toggleEdit}
                >
                  {restProps.children}
                </div>
              );
            }}
          </EditableContext.Consumer>
        ) : (
          restProps.children
        )}
      </td>
    );
  }
}

export default class KeywordTable extends React.Component {
  constructor(props) {
    super(props);
    this.columns = [
      {
        dataIndex: "genre_name",
        editable: true,
        title: "Genre",
        width: "100%"
      }
    ];
  }

  // handleAdd = () => {
  //   const { data } = this.props;
  //   const newData = {
  //     language_name: ""
  //   };
  //   this.props.handleLanguageChange([...data, newData]);
  // };

  handleSave = row => {
    const newData = this.dataFromProps();
    const index = newData.findIndex(itm => row.key === itm.key);
    const item = newData[index];
    newData.splice(index, 1, {
      ...item,
      ...row
    });

    this.props.handleGenreChange(newData);
  };

  render() {
    let data = this.dataFromProps();
    const components = {
      body: {
        cell: EditableCell,
        row: EditableFormRow
      }
    };
    const columns = this.columns.map(col => {
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        onCell: record => ({
          dataIndex: col.dataIndex,
          editable: col.editable,
          handleSave: this.handleSave,
          record,
          title: col.title
        })
      };
    });
    return (
      <div>
        {/* <Button
          onClick={this.handleAdd}
          type="primary"
          style={{ marginBottom: 16 }}
        >
          Add a row
        </Button> */}
        <Table
          components={components}
          rowClassName={() => "editable-row"}
          bordered
          dataSource={data}
          columns={columns}
          pagination={false}
        />
      </div>
    );
  }

  dataFromProps = () => {
    let data = this.props.data || [];
    while (data.length < 3) {
      data.push({ genre_name: "" });
    }
    data = data.map((genre, index) => {
      return { ...genre, key: index };
    });
    return data;
  };
}



// WEBPACK FOOTER //
// ./src/components/PredictionPage/GenreTable.js